import SmartFilters from './SmartFilters';

export default SmartFilters;
